import API from "../../api";
import PrivateAPI from "../../privateApi";
import { put, call } from "redux-saga/effects";
import * as actions from "../actions/index";
import { errorHandler } from "../../helpers/Logger/Logger";
import { DUON_CERTIFIED_ENDPOINT } from "../../helpers/apiEndpoints";

const logError = (error, errorDetails, componentItem, endpoint) => {
  return errorHandler(
    error,
    "API Error",
    errorDetails,
    componentItem,
    endpoint
  );
};

export function* fetchCertifiedItemsSaga(action) {
  try {
    const token = yield call([localStorage, "getItem"], "token");
    if (token) {
      API.defaults.headers.common["Authorization"] = "Bearer " + token;
    }

    const response = yield PrivateAPI.get(duonCertifiedURL());
    yield put(actions.setCertifiedItems(response.data));
  } catch (error) {
    let errorMessage = "DUON Certified Items can't be loaded";
    yield put(actions.fetchCertifiedItemsFailed(errorMessage));
    yield logError(
      error,
      error.response,
      "fetchCertifiedItems",
      duonCertifiedURL()
    );
  }
}

const duonCertifiedURL = () => {
  return DUON_CERTIFIED_ENDPOINT;
};
